/* ============
 * Actions for the auth module
 * ============
 *
 * The actions that are available on the
 * auth module.
 */

import Vue from 'vue';

const LOCALSTORAGE_KEY = 'id_token';

const navigateToHome = () => Vue.router.push({ name: 'home.index' });
const navigateToLogin = () => Vue.router.push({ name: 'login.index' });

function setAuthorizationHeader(token) {
  Vue.$http.defaults.headers.common.Authorization = `Bearer ${token}`;
}

export const check = ({ rootGetters, commit }) => {
  const token = rootGetters['localStorage/getItem'](LOCALSTORAGE_KEY);

  commit('setAuthenticated', !!token);

  if (token) {
    setAuthorizationHeader(token);
  }
};

export const register = ({ dispatch }) => dispatch('login', false);

export const login = ({ commit, dispatch }, toFind = true) => {
  // legacy logics is kept as is
  const token = 'RandomGeneratedToken';

  commit('setAuthenticated', true);
  commit(
    'localStorage/setItem',
    { key: LOCALSTORAGE_KEY, value: token }, { root: true },
  );
  setAuthorizationHeader(token);

  /*
   * Normally you would use a proxy to log the user in:
   *
   * new Proxy()
   *  .login(payload)
   *  .then((response) => {
   *    commit(types.LOGIN, response);
   *    store.dispatch('account/find');
   *    Vue.router.push({
   *      name: 'home.index',
   *    });
   *  })
   *  .catch(() => {
   *    console.log('Request failed...');
   *  });
   */

  (toFind ? dispatch('account/find') : Promise.resolve())
    .then(() => navigateToHome());
};

export const logout = ({ commit }) => {
  commit('setAuthenticated', false);
  commit(
    'localStorage/removeItem',
    { key: LOCALSTORAGE_KEY }, { root: true },
  );
  setAuthorizationHeader('');
  navigateToLogin();
};

export default {
  check,
  register,
  login,
  logout,
};
